import type { CrudSort } from '@refinedev/core';

export const getSortOrder = (
  sorters: CrudSort[],
  field: string
): 'ascend' | 'descend' | null => {
  const s = sorters.find((x) => x.field === field);
  if (!s) return null;
  return s.order === 'asc' ? 'ascend' : 'descend';
};
